export * as fr from './locale/fr/messages';
export * as nl from './locale/nl/messages';
